import React, { useMemo } from "react";
import { server_domain } from "../../../services/constants";
import { htmlString } from "../../../services/helper";

const VoucherDesc = ({ data }) => {
  const { img1, img2 } = useMemo(() => {
    const img1 =
      server_domain?.split("/?")[0] +
      "/" +
      data?.voucher?.lot_picturesISsmallplaintextbox.split("\n")[0];

    const img2 =
      server_domain?.split("/?")[0] +
      "/" +
      data?.voucher?.lot_picturesISsmallplaintextbox.split("\n")[1];

    return { img1, img2 };
  }, [server_domain, data]);

  if (!data.voucher) return null;

  return (
    <div className="pt-5">
      <h4>{data?.voucher?.lot_name}</h4>
      <div className="d-flex gap-2">
        <p>No of people:</p>
        <p>{parseInt(data?.voucher?.lot_no_of_peopleNUM)}</p>
      </div>
      <div
        className="d-sm-grid"
        style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
      >
        <div className="d-flex flex-column gap-1">
          <img
            className="rounded-1 reedem-voucher__desc-image"
            src={img1}
            alt={"img-1"}
            width={220}
            style={{ height: "auto" }}
          />
          <img
            className="rounded-1 reedem-voucher__desc-image"
            src={img2}
            alt={"img-2"}
            width={220}
            style={{ height: "auto" }}
          />
        </div>
        <div>
          <p
            dangerouslySetInnerHTML={{
              __html: htmlString(
                data?.voucher?.lot_descriptionISsmallplaintextbox
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default VoucherDesc;
